import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetUserTeamsQuery,
  GetUserTeamsQueryVariables,
} from "./GetUserTeams.generated";

const GET_USER_TEAMS: TypedDocumentNode<
  GetUserTeamsQuery,
  GetUserTeamsQueryVariables
> = gql`
  query GetUserTeams($uuid: String!) {
    team(uuid: $uuid) {
      uuid
      name
      location
      organization {
        uuid
        allowsDirectMemberAdd
        emailDomain
        emailDomainSecondary
        emailDomainTertiary
        isManualBilling
        stripeCustomerId
      }
      userTeams {
        roleId
        isAdmin
        isSelfSubscribed
        user {
          uuid
          email
          firstName
          lastName
          numAppointmentsUsed
          isDisabled
          account {
            uuid
            accountType
          }
        }
      }
      teamInvites {
        uuid
        timeSent
        timeResponded
        inviteeEmail
        status
        inviteeRoleId
      }
    }
  }
`;

export default GET_USER_TEAMS;
